export default function InvisibleLoading(): JSX.Element {

  return (
    <></>
  );
}
